import { render, staticRenderFns } from "./ModalProofreadResult.vue?vue&type=template&id=3563baec&scoped=true&lang=pug&"
import script from "./ModalProofreadResult.vue?vue&type=script&lang=ts&"
export * from "./ModalProofreadResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3563baec",
  null
  
)

export default component.exports